const YT_VIDEO_ID_RE = /^[a-zA-Z0-9_-]{11}$/;
const YT_THUMBNAIL_RE = /^https:\/\/(i\.ytimg\.com\/vi\/|img\.youtube\.com\/vi\/)[a-zA-Z0-9_-]{11}\/[^\s]+$/;

export function isValidYouTubeVideoId(id: string): boolean {
  return YT_VIDEO_ID_RE.test(id);
}

export function isValidYouTubeThumbnail(url: string): boolean {
  return YT_THUMBNAIL_RE.test(url);
}

export function getSanitizedYouTubeEmbedUrl(videoId: string): string | null {
  if (!isValidYouTubeVideoId(videoId)) return null;
  return `https://www.youtube.com/embed/${videoId}`;
}

export function getSanitizedYouTubeWatchUrl(videoId: string): string | null {
  if (!isValidYouTubeVideoId(videoId)) return null;
  return `https://www.youtube.com/watch?v=${videoId}`;
}

export function getSanitizedYouTubeThumbnail(videoId: string, quality: 'default' | 'mqdefault' | 'hqdefault' | 'sddefault' | 'maxresdefault' = 'mqdefault'): string | null {
  if (!isValidYouTubeVideoId(videoId)) return null;
  return `https://i.ytimg.com/vi/${videoId}/${quality}.jpg`;
}

export function isValidUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
}

export function getSafeAvatarUrl(avatarUrl: string | null | undefined, userName?: string): string {
  if (avatarUrl && isValidUrl(avatarUrl)) return avatarUrl;
  if (userName) {
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(userName)}&background=0D8ABC&color=fff&size=256`;
  }
  return '';
}
